// Mj 版本1.0.0  2023-10-16

import { createApp } from 'vue';
import App from './App.vue';

import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';

import './style.css';

// 引入自定义全局组件
import components from '@/components/index';
// 虚拟列表滚动组件
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import infiniteScroll from 'vue-infinite-scroll';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);
app.use(components);
app.use(VueVirtualScroller);
app.use(infiniteScroll);

app.mount('#app');
